import { Configure } from 'react-instantsearch';

import { ExploreButtons } from './components/ExploreButtons';
import { Header } from './components/Header';
import { PromotedPetitions } from './components/PromotedPetitions';
import { SearchResult } from './components/SearchResult';
import { TopicsSection } from './components/TopicsSection';
import { VirtualWidgets } from './components/VirtualWidgets';
import { usePageBody } from './hooks/usePageBody';

export const PageBody = () => {
	usePageBody();

	return (
		<div className="pb-32">
			<Header />
			<ExploreButtons />
			<TopicsSection />
			<SearchResult />
			<PromotedPetitions />
			<VirtualWidgets />
			<Configure hitsPerPage={8} />
		</div>
	);
};
